<template>
  <div>
    <div class="calendar_main">
      <div class="header flex_center flex_center_align">
        <div class="h_title">2022年7月</div>
      </div>
      <div class="week_box flex_space">
        <div
          v-for="(item, index) in weeks"
          :key="index"
          class="week_item"
          :class="{ red: item.val == '0' }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="day_box flex_start">
        <div
          v-for="(item, index) in dayList"
          :key="index"
          class="day_item"
          :class="sumClass(item, index)"
        >
          <el-popover
            :ref="'popver' + index"
            placement="left"
            width="200"
            trigger="click"
            :offset="10"
            @show="showpopver"
          >
            <div class="mode_box">
              <div class="mode_top">依頼先を選択（2022/07/10）</div>
              <div class="bs_main flex_colum pas">
                <template v-for="(color, cindex) in colorList">
                  <div
                    v-if="
                      item.timeList &&
                      item.timeList.map((ids) => ids.value).includes(color.id)
                    "
                    :key="cindex"
                    class="bs_item flex_center_align no_margin"
                    @click="changeItem(color)"
                  >
                    <div
                      class="yuan"
                      :style="innerColor(color)"
                      :class="{ active: color.active }"
                    >
                      <i></i>
                    </div>
                    <div class="name cname" :style="{ color: color.ys }">
                      {{ color.name }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="flex_end mode_footer">
                <div class="flex_start flex_center_align">
                  <span class="qx" @click="hide(index)">キャンセル</span>
                  <span class="sure" @click="sure(item)">決定</span>
                </div>
              </div>
            </div>
            <div slot="reference" style="width: 100%; height: 100%">
              <div class="day_title">{{ item.val }}</div>
              <div class="round_fix">
                <div
                  v-for="(s, sinde) in item.timeList"
                  :key="sinde"
                  class="round_item"
                  :class="{ active: s.active }"
                  :style="changeColor(s)"
                >
                  <i></i>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>

    <div class="flex_start flex_wrap bs_main">
      <div
        v-for="(item, index) in colorList"
        :key="index"
        class="bs_item flex_start flex_center_align"
      >
        <div class="yuan" :style="{ borderColor: item.ys }"></div>
        <div class="name" :style="{ color: item.ys }">:{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabCalendarSelect',
    data() {
      return {
        weeks: [
          {
            name: '日',
            val: 0,
          },
          {
            name: '月',
            val: 1,
          },
          {
            name: '火',
            val: 2,
          },
          {
            name: '水',
            val: 3,
          },
          {
            name: '木',
            val: 4,
          },
          {
            name: '金',
            val: 5,
          },
          {
            name: '土',
            val: 6,
          },
        ],
        dayList: [
          {
            val: 29,
            week: '0',
          },
          {
            val: 30,
            week: '1',
          },
          {
            val: 31,
            week: '1',
          },
        ],
        colorList: [
          {
            name: 'エスティーム株式会社',
            ys: '#EA5B5C',
            id: 1,
            active: false,
          },
          {
            name: '伊藤産業',
            ys: '#FA7830',
            id: 2,
            active: false,
          },
          {
            name: 'オーテック設備',
            ys: '#42B86A',
            id: 3,
            active: false,
          },
          {
            name: '株式会社 宮田建築設計',
            ys: '#4BA1FF',
            id: 4,
            active: false,
          },
          {
            name: ' アルティオ株式会社',
            ys: '#B077EA',
            id: 5,
            active: false,
          },
        ],
        x: 0,
        y: 0,
        show: false,
      }
    },
    computed: {
      sumClass() {
        return function (row, index) {
          let classData = {}
          if ((index + 1) % 7 == 0) {
            classData.noborder = true
          }
          if (row.week == 0) {
            classData.weekri = true
          }
          if (row?.noList) {
            classData.weekno = true
          }
          return classData
        }
      },
      changeColor() {
        return function (row) {
          let data = {}
          let item = this.colorList.find((obj) => {
            return obj.id == row.value
          })
          if (typeof item != 'undefined') {
            data.borderColor = item.ys
          }
          if (row.active) {
            data.background = item.ys
          }
          return data
        }
      },
      innerColor() {
        return function (row) {
          let data = {}
          data.borderColor = row.ys
          if (row.active) {
            data.background = row.ys
          }
          return data
        }
      },
      showBoxShift() {
        return function (row, val) {
          if (row.isxwList.shift() == val) {
            return true
          } else {
            return false
          }
        }
      },
      showBoxPop() {
        return function (row, val) {
          if (row.isxwList.pop() == val) {
            return true
          } else {
            return false
          }
        }
      },
    },

    mounted() {
      for (let index = 1; index < 32; index++) {
        let str = '2022-06-' + (index < 10 ? '0' + index : index)
        const week = this.getWeek(new Date(str))
        let data = {
          val: index,
          week: week,
        }
        if (index == 1 || index == 2) {
          // data.timeList = [1, 2, 3, 4, 5]
          data.timeList = [
            {
              value: 1,
              active: false,
            },
            {
              value: 2,
              active: false,
            },
            {
              value: 3,
              active: false,
            },
            {
              value: 4,
              active: false,
            },
            {
              value: 5,
              active: false,
            },
          ]
        } else if (index == 5 || index == 25) {
          data.timeList = [
            {
              value: 3,
              active: false,
            },
            {
              value: 4,
              active: true,
            },
            {
              value: 5,
              active: false,
            },
          ]
        } else if (
          index == 6 ||
          index == 9 ||
          index == 13 ||
          index == 14 ||
          index == 19 ||
          index == 18 ||
          index == 22 ||
          index == 26 ||
          index == 28 ||
          index == 29 ||
          index == 31 ||
          index == 15
        ) {
          data.timeList = [
            {
              value: 1,
              active: false,
            },
            {
              value: 2,
              active: false,
            },
            {
              value: 5,
              active: false,
            },
          ]
        } else {
          data.timeList = [
            {
              value: 1,
              active: false,
            },
          ]
        }
        this.dayList.push(data)
      }
      this.dayList.push({
        val: 1,
        week: '5',
      })
    },
    methods: {
      hide(index) {
        this.$refs['popver' + index][0].doClose()
      },
      showpopver() {
        this.colorList.filter((item) => {
          item.active = false
        })
      },
      getWeek(date) {
        return date.getDay()
      },
      changeItem(color) {
        color.active = !color.active
      },
      sure(parent) {
        if (parent.timeList) {
          parent.timeList.filter((item) => {
            this.colorList.filter((son) => {
              if (son.active && item.value == son.id) {
                item.active = true
              }
            })
          })
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin yuan {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-top: 5px;
    border: 2px solid red;
  }
  .calendar_main {
    border: 1px solid #d1dae1;
    border-radius: 4px;
    overflow: hidden;
    .header {
      padding: 16px;
      .h_title {
        font-weight: 600;
        font-size: 16px;
        color: #003350;
      }
      .h_common {
        font-weight: 500;
        font-size: 13px;
        color: #848484;

        &.h_left {
          padding-left: 15px;
          background: url('~@/assets/images/r_left.png') left 1px no-repeat;
        }
        &.h_right {
          padding-right: 15px;
          background: url('~@/assets/images/r_right.png') right 1px no-repeat;
        }
      }
    }
    .week_box {
      width: 100%;
      padding: 5px 0;
      .week_item {
        width: 14.28%;
        font-size: 13px;
        text-align: center;
        color: #666666;
        &.red {
          color: #ea5b5c;
        }
      }
    }
    .day_box {
      width: 100%;
      flex-wrap: wrap;
      position: relative;
      .day_item {
        width: 14.28571428%;
        height: 134px;
        overflow-y: auto;
        border: 1px solid #d1dae1;
        position: relative;
        padding: 6px;
        box-sizing: border-box;
        border-left: none;
        border-bottom: none;
        cursor: pointer;
        .round_fix {
          position: absolute;
          right: 0px;
          bottom: 10px;
          width: 18px;
          .round_item {
            line-height: 26px;
            @include yuan;
            &.bg1 {
              border-color: #ea5b5c;
            }
            &.bg2 {
              border-color: #fa7830;
            }
            &.bg3 {
              border-color: #42b86a;
            }
            &.bg4 {
              border-color: #4ba1ff;
            }
            &.bg5 {
              border-color: #b077ea;
            }
            &.active {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                width: 10px;
                height: 7px;
                display: inline-block;
                border: 1px solid #fff;
                border-width: 0 0 2px 2px;
                transform: rotate(-45deg);
                -ms-transform: rotate(-45deg);
                -moz-transform: rotate(-45deg);
                -webkit-transform: rotate(-45deg);
                -o-transform: rotate(-45deg);
                margin-top: -3px;
              }
            }
          }
        }
        &.noborder {
          border-right: none;
        }
        &.weekri {
          background: #fff6f6;
        }
        .day_title {
          font-weight: 500;
          font-size: 13px;
          text-align: center;
          color: #666666;
          display: block;
          text-align: left;
        }
      }
    }
  }
  .bs_main {
    padding-top: 20px;
    &.pas {
      padding-top: 0px;
      padding-left: 12px;
      padding-right: 12px;
    }
    .bs_item {
      margin-right: 20px;
      padding: 5px 0;
      cursor: pointer;
      .yuan {
        @include yuan;
        margin-top: 0;
        &.active {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            width: 10px;
            height: 7px;
            display: inline-block;
            border: 1px solid #fff;
            border-width: 0 0 2px 2px;
            transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            margin-top: -3px;
          }
        }
      }
      .name {
        font-weight: 400;
        font-size: 13px;
        &.cname {
          padding-left: 5px;
        }
      }
    }
  }
  .mode_box {
    width: 200px;
    position: absolute;
    left: 0;
    top: 0;
    background: #ffffff;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    .mode_top {
      width: 200px;
      height: 26px;
      background: #f7f7f7;
      font-weight: 500;
      font-size: 12px;
      color: #848484;
      line-height: 26px;
      padding-left: 12px;
    }
    .mode_footer {
      padding-right: 8px;
      padding-bottom: 8px;
      .qx {
        font-weight: 500;
        font-size: 13px;
        color: #848484;
        margin-right: 20px;
        cursor: pointer;
      }
      .sure {
        width: 46px;
        height: 28px;
        background: #0060c2;
        border-radius: 3px;
        font-weight: 500;
        font-size: 13px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
</style>
